import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRoute, Event, NavigationStart, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MxPreviousRouteService implements OnDestroy {

    private static ERROR_PAGES: Array<string> = ['/404', '/403', '/500', '/503', '/504'];
    private static NOT_AUTH_PAGES: Array<string> = ['/contact-us', '/registration', '/terms-and-conditions'];
    private static SWITCH_PAGES = new Map<string, string>([
        ['/unsubscribe', '/account']
    ]);
    private previousUrl: string;
    private currentUrl: string;

    private _destroy$$: Subject<null> = new Subject<null>();

    constructor(
        private router: Router) {
        this.currentUrl = this.router.url;
        this.router.events.pipe(takeUntil(this._destroy$$)).subscribe((event: Event) => {
            if (event instanceof NavigationStart && this.currentUrl !== event.url) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            }
        });
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }

    public getPreviousUrl(): string {
        if (!this.previousUrl
            || MxPreviousRouteService.ERROR_PAGES.findIndex(item => item === this.previousUrl) > -1
            || MxPreviousRouteService.NOT_AUTH_PAGES.findIndex(item => item === this.previousUrl) > -1) {
            return '';
        } else {
            let index = this.previousUrl.indexOf('?');
            let url = index >= 0 ? this.previousUrl.substring(0, index) : this.previousUrl;
            return MxPreviousRouteService.SWITCH_PAGES.get(url) ?? this.previousUrl;
        }
    }

    public navigatePreviousPage(): void {
        this.router.navigateByUrl(this.getPreviousUrl());
    }

    public getNavBackFunction(): () => void {
        let url = this.getPreviousUrl();
        return () => {
            this.router.navigateByUrl(url);
        };
    }

    public navigateToParentFunc(route: ActivatedRoute, navigateParentUrl: boolean = true): () => void {
        if (!navigateParentUrl) {
            let url = this.getPreviousUrl();
            return () => {
                this.router.navigateByUrl(url);
            };
        } else {
            return () => {
                this.router.navigate(['../'], {relativeTo: route});
            };
        }
    }

}
